// extracted by mini-css-extract-plugin
export default {"cta":"WG-z","disabled":"XG-z"};